<template>
<v-card class="panel" elevation="1">

    <div class="visits">
        <div class="page-header">
            <div class="left">
                <h2 class="page-title">{{ $page.props.lang.visits_title || "Visits history" }}</h2>
            </div>
        </div>
        
    <v-simple-table v-if="memberData.visits != 0" fixed-header>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              {{ $page.props.lang.visit_time || "Visit time" }}
            </th>
            <th class="text-left">
              {{ $page.props.lang.checkout_time || "Check-out time" }}
            </th>
             <th class="text-left">
              {{ $page.props.lang.membership || "Membership" }}
            </th>
            <th class="text-right"> </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="visit in memberData.visits"
            :key="visit.id"
          >
            <td class="text-left">{{ visit.visit_time }}</td>
            <td class="text-left">{{ visit.checkout_time }}</td>
            <td v-if="visit.membership" class="text-left">{{ visit.membership }}</td>
            <td v-else class="text-left">{{ $page.props.lang.no_membership || "Membership deleted" }}<v-icon class="deleted-visit" color="error">mdi-alert-circle-outline</v-icon></td>
            <td class="text-right">
                  <v-btn @click="deleteVisit(visit.id, true)" :id="'delete' + visit.id" class="delete-icon" icon right>
                      <v-icon center>mdi-trash-can-outline</v-icon>
                      <v-tooltip :activator="'#delete'+ visit.id" bottom open-delay="500">
                          <span>{{$page.props.lang.deleteVisit || "Delete visit"}}</span>
                      </v-tooltip>
                  </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-card-text v-else class="text-center font-weight-light text--disabled">{{ $page.props.lang.no_visits || "Member has no visits so far..."}}</v-card-text>
    
    <ConfirmModal :title="$page.props.lang.confirmModalTitle || 'Confirmation'" :description="$page.props.lang.confirm_delete_visit || 'Are you sure you want to delete this visit?'" :open="deleteVisitModal" @no="deleteVisitModal = false" @yes="deleteVisit(cVisitId, false)"></ConfirmModal>  

</div>
</v-card>
</template>
<style scoped>
   .deleted-visit{
     padding-bottom: 4px; 
     padding-left:3px
   }
</style>
<script>
import AppLayout from '@/js/Layouts/AppLayout'
import MemberLayout from './Layouts/Default'
import ConfirmModal from '@/js/Components/ConfirmModal'
import EventBus from '@/js/eventbus'

export default {
    metaInfo() {
        return{
            title: this.$page.props.member.full_name + ' - ' + (this.$page.props.lang.title || "Visits history")
        }
    },
    name:"MemberVisits",
    components: {
        ConfirmModal
    },
    layout: (h, page) => {
      return h(AppLayout, [
        h(MemberLayout, [page]),
      ])
    },
    props: {
        user:Object,
        member: Object,
        errors: Object,
        lang: Object,
        
    },
    data(){
      return {
        memberData: this.member,
        messageObjects: [],
        deleteVisitModal: false,
        cVisitId: null,
        tablePage: 1,
        tablePageCount: 0,
        itemsPerPage: 8,
        responseErrors: {}
      }
    },
    watch: {
        member: function(value) {
            this.memberData = value
        },
        addModal: function(value) {
            if (value===false) {
                this.responseErrors = {}
                this.note = Object.assign({}, this.resetForm)
            }
        },

        editModal: function(value) {
            if (value===false) {
                this.responseErrors = {}
                this.note = Object.assign({}, this.resetForm)
            }
        }
        
    },

    methods: {
        deleteVisit(id, showConfirmation){
            if(showConfirmation){
                this.deleteVisitModal = true;
                this.cVisitId = id;
                return;
            }
            axios.post('/backoffice/members/deleteVisit', {id: id, member_id: this.memberData.id})
                .then(response => {
                     this.deleteVisitModal = false;
                    if(response.data.status==="OK") {      
                        this.$inertia.reload({only:['member']})
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    }
                })
                .catch(function (error) {
                    this.deleteVisitModal = false;
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                })
            

        }
}

}

</script>